import { ref } from 'vue'

export const globalState = ref({
    observations: [],
    studentObservations: {},
    studentUpgradeBadges: {}
});